// extracted by mini-css-extract-plugin
export default {"searchMenuItem":"_base-requester-picker_searchMenuItem_H6C4U"};